module.exports = __WEBPACK_EXTERNAL_MODULE_97__;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 97
// module chunks = 0